<template>
    <div v-if="!loading" class="productContainer">
        <h2 v-html="productData[0].name "></h2><br>
        <p v-if="productData.length > 1" class="catHeader">{{ $root.language.wsm_chooseProduct }}</p>
        <div class="varients">
           
            <div v-for="product in productData" @click="pickedVariant = product.productId"
                :class="{ 'activeChoice': product.productId == pickedVariant,  'activeChoiceSub' : typeOfPurchase == 'sub' && product.productId == pickedVariant}" 
                class="variantItem" 
                :key="product.productId"> 

                
                
                <div class="choiceContentContainer">
                    <div class="picked">
                        <Transition name="bounce" :duration="{ enter: 500, leave: 0 }">
                            <svg :class="{'issubscriptionCheck' : typeOfPurchase == 'sub'}" v-if="product.productId == pickedVariant" xmlns="http://www.w3.org/2000/svg" height="1em"
                                viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                <path
                                    d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
                            </svg>
                        </Transition>
                        <div class="emptyField"></div>
                        
                    </div>
                    <div class="choiceContent">
                        <div class="typeOf">{{ removeHtmlFromVariant(product.quantityString) }}</div>
                    </div>
                </div>
                <PromotionLabel :promotion="product.promotionAttributes" v-if="product.promotionAttributes && product.promotionAttributes.length > 0"/>
            </div>
        </div>
        <selectversion v-if="admin || localadmin && !oldurl" :pickedProduct="pickedProduct" :pickedVariant="pickedVariant" ></selectversion>
        <!-- <p v-if="pickedProduct.isAllowSubscription" class="catHeader">{{ $root.language.wsm_sub_oneTimePurchase }} /
            {{ $root.language.wsm_sub_subscriptionPurchase }}</p> -->
        <div class="singleOrSub">

            <div @click="changeTypeOfPurchase('single', (typeOfPurchase != 'single'))" :class="{ 'activeChoice': typeOfPurchase == 'single'}"
                class="choiceContainer">
                <div class="choiceContentContainer">
                    <div class="picked">
                        <Transition name="bounce" :duration="{ enter: 500, leave: 0 }">
                            <svg v-if="typeOfPurchase == 'single'" xmlns="http://www.w3.org/2000/svg" height="1em"
                                viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                <path
                                    d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
                            </svg>

                        </Transition>

                        <div class="emptyField"></div>
                    </div>
                    <div class="choiceContent">
                        <div class="typeOf"
                            v-html="pickedProduct.subscription_price ? $root.language.wsm_sub_oneTimePurchase : productData[0].name">
                        </div>
                        <div class="choicePrice">{{ getVisString({
                            price: pickedProduct.price,
                            currencyIso: pickedProduct.CurrencyIso,
                            precision: pickedProduct.currencyPrecision
                        }) }}
                            <p v-if="(pickedProduct.discount > 0 || $root.iscompany) && !$root.pointshop" class="discountYouSave">
                                <additionalInfo :data="pickedProduct" :tax="pickedProduct.taxRateFactor" :issubtype="false"
                                    :showBuyButton="true" :listPrice="getVisString({
                                        price: pickedProduct.listPrice,
                                        currencyIso: pickedProduct.CurrencyIso,
                                        precision: pickedProduct.currencyPrecision
                                    })" :localDiscount="getVisString({
                                        price: pickedProduct.discount,
                                        currencyIso: pickedProduct.CurrencyIso,
                                        precision: pickedProduct.currencyPrecision
                                    })" :companyPriceIncludingVat="pickedProduct.companyPriceIncludingVat">
                                </additionalInfo>
                            </p>
                        </div>
                    </div>
                </div>
                <!--      <div class="extraOnPicked">hehe</div> -->
            </div>

            <div v-if="pickedProduct.isAllowSubscription" @click="changeTypeOfPurchase('sub', (typeOfPurchase != 'sub'))"
                :class="{ 'activeChoice': typeOfPurchase == 'sub', 'flash': flash }" class="choiceContainer subContainer">
                <div class="choiceContentContainer">
                    <div class="picked">
                        <Transition name="bounce" :duration="{ enter: 500, leave: 0 }">
                            <svg v-if="typeOfPurchase == 'sub'" xmlns="http://www.w3.org/2000/svg" height="1em"
                                viewBox="0 0 512 512">
                                <path
                                    d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
                            </svg>

                        </Transition>
                        <div class="emptyField"></div>
                    </div>
                    <div class="choiceContent">
                        <div class="typeOf">
                            {{ $root.language.wsm_sub_subscriptionPurchase }}
                            <span v-if="pickedProduct.subscriptionDiscountPercentage > 0" class="subcta">{{
                                subscriptionDiscountCTA }}</span>
                        </div>
                        <div class="choicePrice">{{ getVisString({
                            price: pickedProduct.subscription_price,
                            currencyIso: pickedProduct.CurrencyIso,
                            precision: pickedProduct.currencyPrecision
                        }) }} / {{ $root.language.wsm_Order }}
                            <p v-if="((pickedProduct.discount > 0 || this.$root.iscompany == 1) || pickedProduct.subscriptionDiscountPercentage > 0) && !$root.pointshop"
                                class="discountYouSave">
                                <additionalInfo :data="pickedProduct" :tax="pickedProduct.taxRateFactor" :issubtype="true"
                                    :showBuyButton="true" :listPrice="getVisString({
                                        price: pickedProduct.listPrice,
                                        currencyIso: pickedProduct.CurrencyIso,
                                        precision: pickedProduct.currencyPrecision
                                    })" :localDiscount="getVisString({
                                            price: pickedProduct.subscriptionDiscount,
                                            currencyIso: pickedProduct.CurrencyIso,
                                            precision: pickedProduct.currencyPrecision
                                        })" :companyPriceIncludingVat="pickedProduct.companyPriceIncludingVat">
                                </additionalInfo>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="extraOnPicked">
                    <div v-if="((isSmallScreen && typeOfPurchase == 'sub') || (!isSmallScreen))" class="subSettings">
                        <p style="font-weight:bold;">{{ $root.language.wsm_sub_interval }}</p>
                        <select v-model="pickedInterval">
                            <option v-for="interval in intervals" :value="interval.freqencyId">{{ interval.name }} {{
                                interval.freqencyId == pickedProduct.recommendedFrequencyId ?
                                `(${$root.language.wsm_sub_recommendedInterval})` : '' }}</option>
                        </select>

                        <p v-html="$root.language.wsm_sub_info_widget_body"></p>
                        <p @click="showSubInfo" class="sub_info">{{ this.$root.language.wsm_sub_info_widget_btntext }}</p>
                    </div>
                </div>
            </div>

        </div>

        <div class="buyContainer">
            <buybuttonv2 @gtag="gtag" @changeTypeOfPurchase="changeTypeOfPurchase" :id="pickedProduct.productId"
                ref="buybutton">
            </buybuttonv2>
        </div>
        <savewithsub @closesubinfo="closesubinfo" v-if="showSubInfoModal"></savewithsub>
    </div>
</template>

<script>
import buybuttonv2 from './components/buybuttonv2.vue';
import additionalInfo from './components/additionalInfo.vue';
import savewithsub from './components/savewithsub.vue';
import selectversion from './components/selectversion.vue';
import PromotionLabel from './components/promotionlabel.vue';
var priceHandler = require('../../globalComponents/visualFormattingForPrices');
import { updateImage, getBasket, updateQuantity, getIntervals} from './productapi'

export default {
    name: 'productPicker',
    components: {
        buybuttonv2,
        additionalInfo,
        savewithsub,
        selectversion,
        PromotionLabel
    },
    props :["admin","localadmin","oldurl"],
    data() {
        return {
            selectedOption: {},
            inputValue:'',
            typeOfPurchase: 'single',
            pickedVariant: '',
            productId: this.$root.id,
            flash: false,
            productData: [],
            loading: true,
            isSmallScreen: window.innerWidth < 768,
            pickedInterval: -1,
            showSubInfoModal: false,
            intervals: [
            ],
        };
    },
    mounted(){
    },
    watch: {
        pickedProduct: {
            handler(newProd) {
                if(!this.loading) {
                    updateImage(newProd);
                    //if they switch product variant, set the interval to the one from the basket or the default
                    getBasket().then(res => {
                        const basket = res.data?.payload?.basket?.lines
                        const currentprod = basket?.find(x => x.productID == newProd.productId)
                        if (basket?.length && currentprod && currentprod.isSubscription) {
                            this.$nextTick(() => {
                                this.pickedInterval = basket?.length && currentprod.intervalReferenceId //set to the one in the basket
                            })
                        } else {
                            this.$nextTick(() => {
                                this.pickedInterval = newProd.recommendedFrequencyId  //set to the recommended one
                            })
                        }
                    })
                    
                }
            }
        },
        pickedInterval: {
            handler(newInterval) {
                if(!this.loading && newInterval != -1) {
                    //If they switch interval, update the product in the basket to the new interval
                    getBasket().then(res => {
                        const basket = res.data?.payload?.basket?.lines
                        if (basket?.length && basket.find(x => x.productID == this.pickedProduct.productId)) {
                            updateQuantity(this.pickedProduct.productId, basket.find(x => x.productID == this.pickedProduct.productId).quantity, basket.find(x => x.productID == this.pickedProduct.productId).isSubscription, newInterval, (this.$root.pointshop == true)).then(quantityRes => {
                                window.ajaxBasket.refresh()
                            })
                        }
                    })
                }
             
            }
        },
        typeOfPurchase: {
            handler(newType, oldType) {
                //if they switch type of purchase (single/sub), update the product in the basket to the new type
                getBasket().then(res => {
                    const basket = res.data?.payload?.basket?.lines
                    if (basket?.length && basket.find(x => x.productID == this.pickedProduct.productId)) {
                        updateQuantity(this.pickedProduct.productId, basket.find(x => x.productID == this.pickedProduct.productId).quantity, (newType == 'sub'), this.pickedInterval, (this.$root.pointshop == "Y" || this.$root.pointshop == true)).then(quantityRes => {
                            window.ajaxBasket.refresh()
                        })
                    }
                })
            }
        }
    },
    async created() {
        window.addEventListener('resize', this.handleResize);
        this.loading = true;
        this.productData = this.$root.productdata.data.products[0].products //get product data for all variants
        //if someone clicked on "save with autpship" or url contains #variant=productID we swap to that variant as the default

        // check if something is in the basket and change settings to the first product in the basket
        getBasket().then(async res => {
            this.intervals = (await getIntervals()).data.subscriptionIntervals.sort((a, b) => {
                const freqA = Number(a.freqency);
                const freqB = Number(b.freqency);
                return freqA - freqB;
            }); //sort intervals by frequency

            this.pickedInterval = this.productData[0].recommendedFrequencyId; //set interval to the recommended interval
            let basket = res.data.payload?.basket.lines;

            let foundProd;
            if (!res.data.isEmpty) {
                this.productData.forEach(productVariation => {
                    if(basket.find(x => x.productID == productVariation.productId)) {
                        foundProd = basket.find(x => x.productID == productVariation.productId)
                    }
                })

                // if we find a product in the basket that matches the variant
                if(foundProd) {

                    if (foundProd.isSubscription) {
                        this.typeOfPurchase = 'sub'; //set the type if it is subscription
                        this.pickedInterval = foundProd.intervalReferenceId //set interval from product in basket
                    }
                    this.pickedVariant = foundProd.productID; //set variant from product in basket
                } else {
                    this.typeOfPurchase = 'single'; //set the type if it is subscription
                    this.pickedVariant = this.productData[0].productId; //set variant from product in basket
                }
            } else {
                this.pickedVariant = this.productData[0].productId; //if basket is empty just pick the first variant
            }

            if (window.location.hash.includes("variant")) {
                this.pickedVariant = /#variant=(\d+)/g.exec(window.location.hash)[1]
                if(foundProd?.productID != this.pickedProduct.productId) {
                    this.typeOfPurchase = 'single';
                    this.pickedInterval = this.productData.find(x => x.productId == this.pickedVariant).recommendedFrequencyId; //set interval to the recommended interval
                } else {
                    this.typeOfPurchase = foundProd.isSubscription ? 'sub' : 'single'; //set the type if it is subscription
                    this.pickedInterval = foundProd.intervalReferenceId //set interval from product in basket
                }
                if(window.location.hash.includes("savewithsub")) {
                    this.flashSub() //flash the sub button
                }
            }

            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('variant')) {
                this.pickedVariant = urlParams.get('variant');
                if(foundProd?.productID != this.pickedProduct.productId) {
                    this.typeOfPurchase = 'single';
                    this.pickedInterval = this.productData.find(x => x.productId == this.pickedVariant).recommendedFrequencyId;
                } else {
                    this.typeOfPurchase = foundProd.isSubscription ? 'sub' : 'single';
                    this.pickedInterval = foundProd.intervalReferenceId;
                }
                if(urlParams.has('savewithsub')) {
                    this.flashSub();
                }
            }

            this.loading = false;
        })

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        closesubinfo() {
            this.showSubInfoModal = false;
        },
        showSubInfo() {
            this.showSubInfoModal = !this.showSubInfoModal
        },
        changeTypeOfPurchase(type, showChangeNotification = false) {
            this.$refs.buybutton.showTypeChange(showChangeNotification); //tell buybutton if it should show that a product has been changed. User might have clicked on the already active typeOfPurchase
            this.typeOfPurchase = type;
          
        },
        handleResize() {
            this.isSmallScreen = window.innerWidth < 768;
        },
        flashSub() {
            let flashAmount = 0;
            let flashAnimation = setInterval(() => {
                this.flash = true;
                setTimeout(() => {
                    this.flash = false;
                    flashAmount++
                }, 200*flashAmount)
                if(flashAmount >= 2) {
                    clearInterval(flashAnimation)
                }
            }, 400);
        },
        gtag() {
            if(!this.$root.pointshop) {
                gtag('event', 'add_to_cart', {
                    currency: this.pickedProduct.CurrencyIso,
                    value: this.pickedProduct.price,
                    "items": [{
                        'item_name': this.pickedProduct.variant_name,
                        'item_id': this.pickedProduct.productId,
                        'price': this.pickedProduct.price
                    }],
                    'event_category': this.typeOfPurchase == 'sub' ? 'Subscription' : 'Single',
                });
                if (typeof window.uetAddToCart === 'function') {
                    window.uetAddToCart({
                        id: this.pickedProduct.productId,
                        price: this.pickedProduct.price,
                        quantity: 1,
                        currency: this.pickedProduct.CurrencyIso,
                        value: this.pickedProduct.price
                    });
                }
                if(window.hasFbq) {
                    fbq('track', 'AddToCart', {
                        content_ids: [this.pickedProduct.productId],
                        content_name: this.pickedProduct.variant_name,
                        currency: this.pickedProduct.CurrencyIso,
                        value: this.pickedProduct.price
                    });
                }
                if(window.hasReddit && window.redditPixelReady && typeof rdt === 'function') {
                    rdt('track', 'AddToCart', {
                        value: this.pickedProduct.price,
                        currency: this.pickedProduct.CurrencyIso,
                        itemCount: 1,
                        conversionId: crypto.randomUUID?.() || String(Date.now()),
                        products: [{
                            id: String(this.pickedProduct.productId),
                            name: this.pickedProduct.variant_name,
                            quantity: 1,
                            itemPrice: this.pickedProduct.price
                        }]
                    });
                }
                    //VWO splittesting
                    window._vis_opt_queue = window._vis_opt_queue || [];
                    window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(200);});
            }
                
        },
        getVisString: function (money) {
            //money, this.prices.CurrencyIso, this.prices.currencyPrecision, this.prices.locale
            return priceHandler.default.visualFormattingForPrices(money.price, money.currencyIso, money.currencyPrecision, window.locale);
        },
        removeHtmlFromVariant(variant) {
            return variant.replace(/<\/?[^>]+(>|$)/g, "");
        }
    },
    computed: {
        pickedProduct() {
            if (this.productData) {
                return this.productData.find(product => product.productId == this.pickedVariant);
            }
        },
        subscriptionDiscountCTA() {
            // pickedProduct.subscriptionDiscountPercentage > 0" class="subcta">Save an additional {{pickedProduct.subscriptionDiscountPercentage}}%
            return this.pickedProduct.discount > 0 ? `${this.$root.language.wsm_sub_saveAdditional.replace('%%DISCOUNT_PERCENTAGE%%', `${this.pickedProduct.subscriptionDiscountPercentage}%`)}` : `${this.$root.language.wsm_sub_checkoutOrderBarText.replace('%%DISCOUNT_PERCENTAGE%%', `${this.pickedProduct.subscriptionDiscountPercentage}%`)}`
        },
    },
}
</script>


<style lang="scss" scoped>
.productContainer {
    margin-top: 1rem;
}
.catHeader {
    font-weight: 900;
    margin: 0;
    color: #3a596f;
    margin-bottom: 2px;
    text-transform: uppercase;
}
.showVersions{
    width: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background-color: #7caf63;
    border: 1px solid #7caf63;
    border-radius: 10px;
    margin-bottom: 5px;
    padding: 5px 20px;
    .select{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        select{
            text-decoration: none;
            border:1px solid #7caf63;
            border-radius: 6px;
            width:60px;
            margin-left: 5px; 
        }
    }
    .comments{
      display: flex;
      flex-direction: row;
      p{
       margin-left: 5px; 
      }
    }
}

.variantItem{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    padding: 0.4rem;
    border-radius: 4px;
    border: 2px solid transparent;
    color: #547d9b;
    background: white;
    min-width: 92px;
    min-height: 2.5rem;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    transform-origin: left;

    // cards with a promotion label get a border in the label colour, so card and strip read as one
    &:has(.promotion-label .special) {
        border-color: #35c1b6;
    }
    &:has(.promotion-label .campaign) {
        border-color: #ffa500;
    }
    &:has(.promotion-label .new) {
        border-color: #2196F3;
    }
    // selected card with a label: green ring outside the label-coloured frame
    &.activeChoice:has(.promotion-label span) {
        box-shadow: 0 0 0 2px #fff, 0 0 0 4px #96ca85, 0px 2px 9px 0px #00000017;
    }
}

.choiceContainer {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    padding: 0.4rem;
    border-radius: 4px;
    border: 2px solid transparent;
    color: #547d9b;
    background: white;
    min-width: 92px;
    min-height: 2.5rem;
    margin-bottom: 1rem;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    overflow: hidden;
    transform-origin: left;


    // .btn_oldVersion{
       
        
    //     display: flex;
    //     flex-direction: row;
    //     justify-content: space-around;
    //     text-decoration: none;
    //     border: none;
    //     padding: 5px;
    //     background-color: #7caf63;
    //     border-radius: 10px;
    //     margin-top: 10px;
    //     .select{
    //         display: inline-block;
    //         select{
    //             text-decoration: none;
    //             border:1px solid #7caf63;
    //         }
    //     }
    // }
    // .btn_oldVersion input{
    //     width: 120px;
    //     border-radius: 8px;
    //     text-decoration: none;
    //     border: none;
    //     text-align: center;
    // }
}

.choiceContainer, .variantItem {
    &:not(.activeChoice) {
        &:hover {
            background: white;
            box-shadow: 0px 2px 9px 0px #00000017;
        }

        .typeOf {
            font-weight: normal !important;
        }
    }

    &.activeChoice {
        border: 2px solid #96ca85;
        box-shadow: 0px 2px 9px 0px #00000017;
    }
    &.activeChoiceSub {
        border: 2px solid #d8a64b;
    }
    &.subContainer.flash {
        border: 2px solid #d8a64b;
        }
    &.subContainer {
        transition: all 0.2s ease-in-out;


        //#d8a64b
        &.activeChoice {
            border: 2px solid #d8a64b;
        }

        .picked {
            svg {
                fill: #d8a64b !important;
            }
        }
    }
}


.choiceContainer .subSettings {
    display: flex;
    flex-direction: column;
    background: inherit;
    justify-content: flex-start;
    text-align: left;
    align-items: flex-start !important;
    margin-bottom: 1rem;
    padding-left: 1rem;
    margin-top: 1rem !important;
    width: 100%;
    border-radius: 4px;

    .sub_info {
        color: #3f95b4;
        text-decoration: underline;
    }

    select {
        border-radius: 4px;
        background: white;
        color: #547d9b;
        font-weight: bold;
        font-size: 1.1rem;
        border: 1px solid;

        option {
            background: white;
        }
    }

    p {
        color: #446485;
        font-weight: normal;
        padding-right: 1rem;
    }
}

.choiceContentContainer {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;

    .picked {
        width: 33px;
        height: 24px;
        position: relative;
        margin-right: 10px;

        svg {
            display: block;
            font-size: 1.6rem;
            fill: #7caf63;
            z-index: 10;
            position: relative;
        }

        .issubscriptionCheck {
            fill: #d8a64b;
        }
        .emptyField {
            position: absolute;
            top: 0px;
            z-index: 0;
            left: 0px;
            width: 20px;
            border-radius: 25px;
            border: 2px solid #d2d2d2;
            height: 20px;
            margin-right: 7px;
            background: #f2f2f2;
        }
    }
}

.choiceContentContainer .choiceContent {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    .discountYouSave {
        margin: 0;
        font-weight: normal;
        font-size: 0.8rem;
        color: gray;
    }

    .typeOf,
    .choicePrice {
        display: flex;
        flex-direction: column;
        color: #547d9b;
        font-size: 1.2rem;
        font-weight: bold;
        align-items: flex-end;

        .subcta {
            color: #e8b75e;
            font-size: 0.8rem;
            font-weight: 900;
        }
    }

    .typeOf {

        align-items: flex-start;
    }
}

//specific css
.varients {
    display: flex;
    margin-bottom: 2rem;
    flex-wrap: wrap;
    gap: 20px;

    .choiceContainer {
        margin-right: 1rem;
        &:nth-last-child(1) {
            margin-right: 0;
        }
    }
}

.extraMargin {
    margin-bottom:2.5rem;
}

.buyContainer {
    display: flex;
    background: white;
    padding: 1.2rem;
    border-radius: 4px;
    box-shadow: 0 0 15px 0px #0000000d;
    min-height: 29px;

    .price {
        font-size: 1.6rem;
        color: #446485;
        line-height: 1.6rem;
        margin-bottom: 0.8rem;
    }

    .addToCard {
        display: flex;
        height: 2.6rem;

        .quantityBtns {
            display: flex;
            margin-right: 1rem;

            button {
                background: #7caf63;
                outline: none;
                border: none;
                color: white;
                font-weight: bold;
                width: 2.4rem;
                border-radius: 0;
                cursor: pointer;

                &:hover {
                    background: #92cd75;
                }

                svg {
                    fill: white;
                }
            }

            input {
                width: 2rem;
                padding: 0.2rem;
                border: none;
                border-top: 1px solid;
                border-bottom: 1px solid;
                font-size: 1.4rem;
                text-align: center;
                background: white;
                color: #4b4b4b;
                margin-bottom: 0;
                border-color: #b7b7b7;
            }

            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
        }

        .addToCardBtn {
            background: #7caf63;
            outline: none;
            border: none;
            width: 100%;
            color: white;
            font-weight: bold;
            cursor: pointer;

            &:hover {
                background: #92cd75;
            }
        }

    }
}

.bounce-enter-active {
    animation: bounce-in 0.2s;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}


.fadeinUp-enter-active {
    animation: fadein-up 0.4s;
}

@keyframes fadein-up {
    from {
        transform: translate3d(0, 10px, 0);
        opacity: 0;
    }

    to {
        transform: translate3d(0, 0, 0);
        opacity: 1
    }
}

@media screen and (max-width: 400px) {
    .choiceContainer .choiceContentContainer .choiceContent .choicePrice, .typeOf {
        font-size: 1rem !important;

    }
}

</style>